import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import NotificationsPage from "src/components/notifications/NotificationsPage";
import { RODEO_PAGE_NAME } from "src/_config";

const NotificationsContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.NOTIFICATIONS} />
      <NotificationsPage />
      <Footer variant="dashboard" />
    </>
  );
};

export default NotificationsContainer;
